/*
 * @Author       : 花裤衩<白永明><yongming.bai@outlook.com>
 * @Date         : 2025-12-19 13:57:03 +0800
 * @LastEditors  : 花裤衩<白永明><yongming.bai@outlook.com>
 * @LastEditTime : 2026-07-17 12:03:11 +0800
 * @FilePath     : /ai-agent-lumina/src/directives/img-src.js
 * @Description  : 用于img的指令  替代原生src  监听图片加载情况  如果加载失败  使用默认占位图
 * v-img-src="url"
 * v-img-src="{ src: '', fallback: 'src失败或者空值是默认显示的图片' }"
 */
// 最终默认
import placeholder from '@/assets/img/error.png'
import avatar from '@/assets/img/default-avatar.png'

export default {
  mounted(el, binding) {
    setImage(el, binding)
  },
  updated(el, binding) {
    if (JSON.stringify(binding.value) !== JSON.stringify(binding.oldValue)) {
      setImage(el, binding)
    }
  }
}

function setImage(el, binding) {
  el.dataset.imgStatus = '' // loading
  // 兼容两种写法：v-img-src="url" 或 v-img-src="{ src, fallback }"
  let imgUrl = null
  let fallbackImg = binding.modifiers.avatar ? avatar : placeholder

  const value = binding.value

  if (typeof value === "string") {
    imgUrl = value
  } else if (value && typeof value === "object") {
    imgUrl = value.src
    fallbackImg = value.fallback || placeholder
  }

  // 设置图片
  el.src = imgUrl || fallbackImg

  // 自动适配展示方式
  if (!imgUrl) el.style.objectFit =  "cover"
  // 加载失败
  el.onerror = () => {
    el.src = fallbackImg
    el.style.objectFit = "cover"
    el.dataset.imgStatus = ''
  }
  // 加载成功
  el.onload = () => {
    el.dataset.imgStatus = ''
  }
}

